define('viewmodels/ProductRiskRating/ProductRiskRatingDashboard',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {
        var app = require('durandal/app'),
            ko = require('knockout');

        var ProductRiskRatingDashboardVM = {
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            currentPageNumber: ko.observable(),
            RouteFromTrackingToResponseScreen: RouteFromTrackingToResponseScreen,
            SelectedPorductAssignmentID: ko.observable(),
            SelectedStatus: ko.observable(),
            // Dashboard Notifications
            assignmentsCount: ko.observable(0),
            workInProgressCount: ko.observable(0),
            completedCount: ko.observable(0),
            notificationsCount: ko.observable(0),
            // Roles
            GetAllUserRole: GetAllUserRole,
            RolesDrpDwnList: ko.observableArray([]),
            RoleValue: ko.observable(),
            rolesDropdownEvent: rolesDropdownEvent,
            ResponseMoveArray: ko.observable(),
            // Get Inforamtion about PRRDashboard
            GetPRRDashboard: GetPRRDashboard,
            GetAllDataInNotifications: GetAllDataInNotifications,
            GetAllDataInNewAssignments: GetAllDataInNewAssignments,
            GetAllDataInWorkInProgress: GetAllDataInWorkInProgress,
            GetAllDataInCompleted: GetAllDataInCompleted,
            // Notifications 
            NotificationsCount: ko.observable(0),
            Notificationlist: ko.observableArray(),
            //New Assignments
            AssignedCount: ko.observable(0),
            Assignmentlist: ko.observableArray([]),
            NewAssignmentClick: NewAssignmentClick,
            MoveProductToWorkInProgress: MoveProductToWorkInProgress,
            ProductMoveArray: ko.observableArray(),
            // Work In Progress
            WorkInProgressCount: ko.observable(0),
            WorkInProgresslist: ko.observableArray(),
            WIPClick: WIPClick,
            //Completed 
            CompletedCount: ko.observable(0),
            CompletedList: ko.observableArray(),
        };

        return ProductRiskRatingDashboardVM;

        var RaTableObj = false;
        var NotificationTblObj = false;
        var CompletedTblObj = false;

        function attached() {
            GetAllUserRole();
            //GetPRRDashboard();

            RaTableObj = $('#tblNewAssignment').DataTable({ "bVisible": false });
            $('#tblNewAssignment').on('page.dt', function (event) {
                ProductRiskRatingDashboardVM.currentPageNumber(RaTableObj.page());
            });

            WIPTableObj = $('#tblWorkInProgress').DataTable({ "bVisible": false });
            $('#tblWorkInProgress').on('page.dt', function (event) {
                ProductRiskRatingDashboardVM.currentPageNumber(WIPTableObj.page());
            });


            CompletedTblObj = $('#tblCompleted').DataTable({ "bVisible": false });
            $('#tblCompleted').on('page.dt', function (event) {
                ProductRiskRatingDashboardVM.currentPageNumber(CompletedTblObj.page());
            });

            NotificationTblObj = $('#tblNotification').DataTable();
        }

        function detached() {
        }


        /**
          * Get All Roles for logged user
          */
        function GetAllUserRole() {
            try {
                $.ajax({
                    url: "/api/Survey/GetAllUserRole",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | source: GetAllUserRole() in ProductRiskRatingDashboard.js';
                logger.logMessage(msg)
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    ProductRiskRatingDashboardVM.RolesDrpDwnList([]);
                    if (jsonResult != null) {
                        var mappedRole = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });
                        ProductRiskRatingDashboardVM.RolesDrpDwnList(mappedRole);
                        GetPRRDashboard();

                    }
                    else {
                        ProductRiskRatingDashboardVM.RolesDrpDwnList([]);
                    }
                }
                catch (e) {
                    var msg = 'exception' + e + ' | source: ajaxSucess() in GetAllUserRole() in ProductRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUserRole() method in ProductRiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUserRole() method in ProductRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        function rolesDropdownEvent(data, event) {
            try {
                if (ProductRiskRatingDashboardVM.RolesDrpDwnList().length != 0) {
                    if (ProductRiskRatingDashboardVM.ProductMoveArray() != undefined && ProductRiskRatingDashboardVM.ProductMoveArray().length != 0) {
                        
                        if (ProductRiskRatingDashboardVM.RolesDrpDwnList()[0].RoleId() != ProductRiskRatingDashboardVM.ProductMoveArray().RoleID()) {
                            ProductRiskRatingDashboardVM.RoleValue(ProductRiskRatingDashboardVM.ProductMoveArray().RoleID());
                            document.getElementById('RoleDrpDown').options[document.getElementById('RoleDrpDown').selectedIndex].innerText = ProductRiskRatingDashboardVM.ProductMoveArray().RoleName();
                            ProductRiskRatingDashboardVM.ProductMoveArray([]);
                        }
                    }
                    if (ProductRiskRatingDashboardVM.RolesDrpDwnList() != '') {
                        GetPRRDashboard();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | surveydropdownevent() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }


        /**
         * Call each function for getting data for the tables
         */
        function GetPRRDashboard() {
            try {
                $('#divTables').hide();
                $('#loadingImgforDashboard').show();
                //GetAllDataInNotifications();
                GetAllDataInNewAssignments().then(function () {
                    GetAllDataInWorkInProgress().then(function () {
                        GetAllDataInCompleted().then(function () {
                            $('#loadingImgforDashboard').hide();
                            $('#dashboardStatuses').show();
                            $('#divTables').show();
                        })
                    })
                })

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetPRRDashboard() in ProductRiskRatingDashboard.js';
                logger.logMessage(msg);
            }
        }


        /**
        * Get All Products for NewAssignment Table
        */
        function GetAllDataInNewAssignments() {
            var roleID = ko.toJS(ProductRiskRatingDashboardVM.RoleValue());
            try {
                return $.ajax({
                    url: "/api/productDashboard/getNewAssignments",
                    data: { 'isStarted': 0, 'userRoleID': roleID },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllNewAssignment() in ProductRiskRatingDashboard.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, Success) {
                try {
                    if (jsonResult != null) {
                        ProductRiskRatingDashboardVM.Assignmentlist([]);
                        ProductRiskRatingDashboardVM.appsecurity.WriteAccess('true');
                        ProductRiskRatingDashboardVM.AssignedCount(jsonResult.length);

                        RaTableObj.clear().destroy();
                        $('#tblNewAssignment tbody tr').remove();

                        var mappedProducts = $.map(jsonResult, function (result) {
                            return new GenericModel(result);
                        });

                        ProductRiskRatingDashboardVM.Assignmentlist(mappedProducts);

                        RaTableObj = undefined;
                        RaTableObj = $('#tblNewAssignment').DataTable({
                            "aLengthMenu": [5, 10, 25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false,
                                "bSortable": false
                            }, {
                                "aTargets": [1],
                                "bSortable": false
                            }, {
                                "aTargets": [2],
                                "bSearchable": false,
                                "bSortable": false
                            }]
                        });
                        RaTableObj.draw();
                        ProductRiskRatingDashboardVM.currentPageNumber(RaTableObj.page());
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the New Assignments queue.', 'Error', system.getModuleId(ProductRiskRatingDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllNewAssignment() in ProductRiskRatingDashboard.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllNewAssignment() method in ProductRiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllNewAssignment() method in ProductRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        function NewAssignmentClick(data, event) {
            try {
                var AssignmentID = data.AssignmentID;
                var ProdcutID = data.ID;

                app.showMessage('Do you want to move selected product to your Work In Progress list?', 'Move Product', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-exchange text-default' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            MoveProductToWorkInProgress(AssignmentID, ProdcutID);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NewAssignmentClick() in ProductRiskRatingDashboard.js';
                logger.logMessage(msg);
            }
        }

        /**
         * Methid for moving product from NewAssignment List to WorkInProgress List
         */
        function MoveProductToWorkInProgress(AssignmentID, ProdcutID) {

            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/productDashboard/moveToWorkInProgress?assignmentID=" + AssignmentID,
                    headers: headers,
                    type: "PUT",
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajax call in MoveProductToWorkInProgress() in ProductRiskRatingDashboard.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    logger.logSuccess('Product has been moved to the Working queue successfully.', 'Success', system.getModuleId(ProductRiskRatingDashboardVM), true);
                    GetAllDataInNewAssignments();
                    GetAllDataInWorkInProgress();
                }
                catch (e) {
                    var msg = 'Exception' + e + 'Source: ajaxSuccess in MoveProductToWorkInProgress() in ProdcutRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    router.navigate("configuration", true);

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in MoveProductToWorkInProgress() method in ProdcutRiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in MoveProductToWorkInProgress() method in ProdcutRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        /**
         * Get All Products for WorkInPtogress Table
         */
        function GetAllDataInWorkInProgress() {
            try {
                var roleID = ko.toJS(ProductRiskRatingDashboardVM.RoleValue());
                return $.ajax({
                    url: "/api/productDashboard/getNewAssignments",
                    data: { 'isStarted': 1, 'userRoleID': roleID },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllDataInWorkInProgress() in ProductRiskRatingDashboard.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null) {
                        ProductRiskRatingDashboardVM.WorkInProgresslist([]);
                        ProductRiskRatingDashboardVM.appsecurity.WriteAccess('true');
                        ProductRiskRatingDashboardVM.WorkInProgressCount(jsonResult.length);

                        WIPTableObj.clear().destroy();
                        $('#tblWorkInProgress tbody tr').remove();

                        var mappedProducts = $.map(jsonResult, function (result) {
                            return new GenericModel(result);
                        });
                        ProductRiskRatingDashboardVM.WorkInProgresslist(mappedProducts);

                        WIPTableObj = undefined;
                        WIPTableObj = $('#tblWorkInProgress').DataTable({
                            "aLengthMenu": [5, 10, 25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false,
                                "bSortable": false
                            }, {
                                "aTargets": [1],
                                "bSortable": false
                            }, {
                                "aTargets": [2],
                                "bSearchable": false,
                                "bSortable": false
                            },
                            {
                                "aTargets": [3],
                                "bSearchable": false,
                                "bSortable": false
                            }]
                        });
                        WIPTableObj.draw();
                        ProductRiskRatingDashboardVM.currentPageNumber(WIPTableObj.page());

                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the Work In Progress queue.', 'Error', system.getModuleId(ProductRiskRatingDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllDataInWorkInProgress() in ProductRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllDataInWorkInProgress() method in ProductRiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllDataInWorkInProgress() method in ProductRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        /**
         * Navigation to Product Details
         */
        function WIPClick(data, event) {
            try {
                var productID = data.ID;
                var AssignmentID = data.AssignmentID;
                var productName = data.Name();
                var LaunchDate = data.LaunchDate();
                var RoleID = ProductRiskRatingDashboardVM.RoleValue();
                var SelectedRoleName = '';
                var Status = '';

                if (event.currentTarget.parentNode.parentNode.parentNode.parentNode.id == "tblCompleted")
                    Status = "Completed";
                else
                    Status = "In Progress";

                var SelectedRoleName = document.getElementById('RoleDrpDown').options[document.getElementById('RoleDrpDown').selectedIndex].innerText;
                ProductRiskRatingDashboardVM.SelectedPorductAssignmentID(AssignmentID);
                ProductRiskRatingDashboardVM.SelectedStatus(Status);

                router.navigate("#ProductRiskRating/ProductDetailsPage/", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | WIPClick() in ProductRiskFactorDashboard.js';
                logger.logMessage(msg);
            }
        }

        function RouteFromTrackingToResponseScreen(productID, productName, LaunchDate, RoleID, SelectedRoleName, Status) {
            try {
                ProductRiskRatingDashboardVM.RoutedFrom("Tracking");
                ProductRiskRatingDashboardVM.ProductMoveArray(new ProductMoveModel({
                    ID: productID,
                    Name: productName,
                    //PageHeaderName: SurveyTypeName, 
                    LaunchDate: LaunchDate,
                    Status: Status,
                    RoleID: RoleID,
                    SelectedRoleName: SelectedRoleName,
                }));

                // router.navigate("#survey/SurveyResponse", true);
                router.navigate("#survey/ProductDetailsPage", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | RouteFromTrackingToResponseScreen() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }


        function GetAllDataInCompleted() {
            try {
                var roleID = ko.toJS(ProductRiskRatingDashboardVM.RoleValue());
                return $.ajax({
                    url: "/api/productDashboard/getNewAssignments",
                    data: { 'isStarted': 0, 'userRoleID': roleID },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllDataInCompleted() in ProductRiskRatingDashboard.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, Success) {
                try {
                    if (jsonResult != null) {
                        ProductRiskRatingDashboardVM.CompletedList([]);
                        ProductRiskRatingDashboardVM.appsecurity.WriteAccess('true');
                        ProductRiskRatingDashboardVM.CompletedCount(jsonResult.length);

                        CompletedTblObj.clear().destroy();
                        $('#tblCompleted tbody tr').remove();

                        var mappedProducts = $.map(jsonResult, function (result) {
                            return new GenericModel(result);
                        });

                        ProductRiskRatingDashboardVM.CompletedList(mappedProducts);

                        CompletedTblObj = undefined;
                        CompletedTblObj = $('#tblCompleted').DataTable({
                            "aLengthMenu": [5, 10, 25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false,
                                "bSortable": false
                            }, {
                                "aTargets": [1],
                                "bSortable": false
                            }, {
                                "aTargets": [2],
                                "bSearchable": false,
                                "bSortable": false
                            }]
                        });
                        CompletedTblObj.draw();
                        ProductRiskRatingDashboardVM.currentPageNumber(CompletedTblObj.page());
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the Completed queue.', 'Error', system.getModuleId(ProductRiskRatingDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllDataInCompleted() in ProductRiskRatingDashboard.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllDataInCompleted() method in ProductRiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllDataInCompleted() method in ProductRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetAllDataInNotifications() {

        }
        
        // Models 

        function RoleModel(item) {
            try {
                var self = this;
                self.RoleId = ko.observable(item.RoleId);
                self.RoleName = ko.observable($('<div/>').html(item.RoleName).text());
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: RoleModel() in ProductRiskRatingDashboard.js';
                logger.logMessage(msg);
            }
        }

        function ProductMoveModel(item) {
            try {
                var self = this;
                self.ID = item.ID || null;
                self.Name = ko.observable(item.Name || '');
                self.LaunchDate = ko.observable(item.LaunchDate || '');
                self.Status = ko.observable(item.Status);
                self.RoleID = ko.observable(item.RoleID);
                self.SelectedRoleName = ko.observable(item.SelectedRoleName);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in ProductRiskRatingDashboard.js';
                logger.logMessage(msg);
            }
        }

        function GenericModel(item) {
            try {
                var self = this;
                //Products
                self.ID = item.ID || null;
                self.AssignmentID = item.AssignmentID;
                self.Name = ko.observable(item.Name || '');
                self.LaunchDate = ko.observable(item.LaunchDate || '');
                self.Status = ko.observable(item.Status);

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: GenericModel() in ProductRiskRatingDashBoard.js';
                logger.logMessage(msg);
            }
        }

    });
